import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/images/my/medal.png'


const _hoisted_1 = { class: "bg" }
const _hoisted_2 = { class: "logo_bg" }
const _hoisted_3 = { class: "min_head" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "head_name_wrap" }
const _hoisted_7 = { class: "username_icon" }
const _hoisted_8 = { class: "user_tips" }
const _hoisted_9 = { class: "nav_wrapper" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "item_num" }
const _hoisted_12 = { class: "item_name" }
const _hoisted_13 = { class: "medal_entry_left" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "medal_entry_right" }
const _hoisted_16 = { class: "business_div" }
const _hoisted_17 = { class: "business_title" }
const _hoisted_18 = { class: "business_wrapper" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "item_img_box" }
const _hoisted_21 = {
  key: 0,
  class: "badge"
}
const _hoisted_22 = { class: "item_img_name" }
const _hoisted_23 = { class: "business_div" }
const _hoisted_24 = { class: "business_title" }
const _hoisted_25 = { class: "business_wrapper" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "item_img_box" }
const _hoisted_28 = {
  key: 0,
  class: "badge"
}
const _hoisted_29 = { class: "item_img_name" }

import {
  ComponentInternalInstance,
  getCurrentInstance,
  reactive,
  toRefs,
  ref,
  onMounted,
  onActivated,
  computed
} from 'vue'
import { useRouter } from 'vue-router'
import { Icon } from 'vant'
import { getUserSimple } from '@/api/requests/RankRequests'
import { getValidateToken } from '@/api/requests/UserRequests'
import { getCornerMarkNumber } from '@/api/requests/TeachManageRequests'
import QrCodeScanner from '@/components/QRCodeScanner.vue'
import { isTudoApp } from '@/utils/tudo'
import { isWisdomRabbitApp } from '@/utils/sandsTalkSmartRabbit'
import { isOutFieldApp } from '@/utils/outfield'
import { isSandsTalkFlutterApp } from '@/utils/sandsTalkFlutter'
import { isSandsTalkMSFlutterApp } from '@/utils/sandsTalkMSFlutter'
import { isSandsTalkNativeApp } from '@/utils/sandsTalkNative'
import { isSandsTalkSEAsiaOutfieldApp } from '@/utils/sandsTalkSEAsiaOutfield'
import { isSandsTalkPhOutfieldApp } from '@/utils/sandsTalkPhOutfiled'
import { toW, toHour } from '@/utils'
import { useAuthStore } from '@/stores/login'
import { getUserLabelInfo } from '@/api/requests/AppRequests'
import { getMyMedalSummary } from '@/api/requests/MyMedal'

export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const router = useRouter()
const { proxy } = getCurrentInstance() as ComponentInternalInstance

const userInfoData = reactive<{
  username?: string
  jobDesc?: string
  avatarUrl?: string
}>({
  username: '',
  jobDesc: '',
  avatarUrl: require('@/assets/images/wx_share_default.jpg')
})

let isFirstLoad = true
const { avatarUrl, jobDesc } = toRefs(userInfoData)
const authStore = useAuthStore()
const wearImageUrl = computed(() => authStore.wearImageUrl)
const moreScreen = ref()
const personName = ref()
const myMedalSummary = ref<{ awardCount: number } | null>(null)
const medalCount = computed(() => {
  const raw = myMedalSummary.value?.awardCount
  const parsed = typeof raw === 'number' ? raw : Number(raw || 0)
  if (!Number.isNaN(parsed) && parsed > 0) return parsed
  return 0
})
const navScreen = ref([
  {
    name: 'study_time_h5',
    num: '24',
    to: '/studyTime'
  },
  {
    name: 'top_academic_h5',
    num: '9875',
    to: '/topAcademic'
  },
  {
    name: 'total_Integral_h5',
    num: '1.29',
    to: '/integral'
  }
])

// 注意数据顺序，不然影响显示徽标数据
const myScreen = ref([
  {
    name: 'app_my_studies',
    img: 'icon-icon_wode_xuexi',
    to: '/myStudy'
  },
  {
    name: 'app_my_training', // 培新项目
    img: 'icon-icon_wode_wodepeixun',
    to: '/myTraining',
    badgeNum: 0
  },
  {
    name: 'app_my_examination', // 考试与练习
    img: 'icon-icon_wode_kaoshi',
    to: '/examPractise',
    badgeNum: 0
  },
  {
    name: 'app_my_survey', // 调查
    img: 'icon-icon_wode_tiaoyan',
    to: '/mySurvey',
    badgeNum: 0
  },
  {
    name: 'app_offline_teaching',
    img: 'icon-xianxiamianshou',
    to: '/faceTeaching'
  },
  {
    name: 'certificate',
    img: 'icon-zhengshuguanli',
    to: '/myCertificate'
  },
  {
    name: 'pc_community_my_release',
    img: 'icon-icon_wode_wodefabu',
    to: '/myPublish'
  },
  {
    name: 'pc_common_my_love',
    img: 'icon-icon_wode_shoucang',
    to: '/myCollect'
  },
  {
    name: 'file_archive',
    img: 'icon-dangan',
    to: '/myArchive'
  },
  {
    name: '勋章',
    img: 'icon-xunzhang',
    to: '/myMedalList'
  }
])

const moreScreenData1 = [
  {
    name: 'app_feedback',
    img: 'icon-icon_wode_fankui',
    to: '/feedback'
  }
]
const moreScreenData = [
  {
    // 管理员工作台入口
    name: '管理中心',
    img: 'icon-wode-guanli',
    to: '/workBench',
    show: false
  },
  {
    // 团队学习
    name: 'pc_my_team',
    img: 'icon-wode_tuanduixuexi',
    to: '/teamStudyList',
    show: false
  },
  {
    // 教学管理
    name: 'teaching_management', // app_
    img: 'icon-pic_jiaoxueguanli1',
    to: '/teachManage/TeachManageList',
    badgeNum: 0,
    show: false
  },
  {
    name: 'app_my_center',
    img: 'icon-gengduo_gerenzhongxin',
    to: '/personCenter',
    show: true
  },
  {
    name: 'app_feedback',
    img: 'icon-icon_wode_fankui',
    to: '/feedback',
    show: true
  },
  {
    name: 'settings',
    img: 'icon-icon_wode_shezhi',
    to: '/setting',
    show: true
  },
  {
    name: '帮助中心',
    img: 'icon-wode-bangzhu',
    to: '/helpCenter',
    show: true
  }
]

const handleMenu = async () => {
  if (isTudoApp || isOutFieldApp) {
    moreScreen.value = moreScreenData1
    return
  }
  // 保留：获取并修复 userId
  const res = await getValidateToken()
  if (res.code === 1) {
    const authStore = useAuthStore()
    const { setUserId, setWearImageId, setWearImageUrl, setRoleCodes } = authStore
    setUserId(res.data.id)
    setWearImageId(res.data.wearImageId || '')
    setWearImageUrl(res.data.wearImageUrl || '')
    setRoleCodes(res.data.roleCodes || [])
  }

  // 新增：通过 getUserLabelInfo 判断入口显示
  const labelRes = await getUserLabelInfo()
  if (labelRes.code === 1) {
    const { teachingMgtLabel = 0, teamLearningLabel = 0, workbenchLabel = 0 } = labelRes.data || {}
    const map: Record<string, boolean> = {
      '/teamStudyList': teamLearningLabel === 1,
      '/teachManage/TeachManageList': teachingMgtLabel === 1,
      '/workBench': workbenchLabel === 1
    }
    Object.keys(map).forEach((to) => {
      const item = moreScreenData.find((e) => e.to === to)
      if (item) item.show = map[to]
    })
    moreScreen.value = moreScreenData.filter((item) => item.show)
  } else {
    ;['/teamStudyList', '/teachManage/TeachManageList', '/workBench'].forEach((to) => {
      const item = moreScreenData.find((e) => e.to === to)
      if (item) item.show = false
    })
    moreScreen.value = moreScreenData.filter((item) => item.show)
  }
}
const onPrivacy = (value: string) => {
  router.push(`/${value}`)
}

const goJump = (value: string) => {
  router.push(value)
}

const handleAdd = async (result: string) => {
  await router.push({ name: 'TrainingLink', query: { linkUrl: result } })
}

const getSimple = async () => {
  const res = await getUserSimple({})
  if (res.code === 1) {
    const { totalStudyDuringTime, monthRank, totalPoints } = res.data
    const { name, postName, avatarFileUrl } = res.data.user
    personName.value = name
    userInfoData.username = name
    userInfoData.jobDesc = postName
    userInfoData.avatarUrl = avatarFileUrl || require('@/assets/images/wx_share_default.jpg')
    navScreen.value[0].num = toW(toHour(totalStudyDuringTime, 'H')) || '0'
    navScreen.value[1].num = toW(monthRank) || '0'
    navScreen.value[2].num = toW(totalPoints) || '0'
    proxy?.$forceUpdate()
  }
}

const fetchMyMedalSummary = async () => {
  const res = await getMyMedalSummary()
  if (res?.success === true && res?.data) {
    myMedalSummary.value = res.data
    return
  }
  if ((res?.code === 1 || res?.code === 214) && res?.data) {
    myMedalSummary.value = res.data
    return
  }
  myMedalSummary.value = null
}
// 获取徽标
const getBadge = async () => {
  const res = await getCornerMarkNumber()
  if (res.code === 1) {
    const { trainingNumber, examAndPracticeNumber, investigationNumber, teachingNumber, faceNumber } = res.data

    const setBadge = (list: any[], name: string, num: any) => {
      const item = list.find((i) => i.name === name)
      if (item) item.badgeNum = Number(num || 0)
    }
    setBadge(myScreen.value, 'app_my_training', trainingNumber)
    setBadge(myScreen.value, 'app_my_examination', examAndPracticeNumber)
    setBadge(myScreen.value, 'app_my_survey', investigationNumber)
    setBadge(myScreen.value, 'app_offline_teaching', faceNumber)
    setBadge(moreScreenData, 'teaching_management', teachingNumber)
    if (moreScreen.value) {
      setBadge(moreScreen.value, 'teaching_management', teachingNumber)
    }
  }
}

onActivated(() => {
  if (!isFirstLoad) {
    handleMenu()
    getSimple()
    getBadge()
    fetchMyMedalSummary()
  }
})

onMounted(() => {
  console.log('onMounted')
  if (isFirstLoad) {
    getSimple()
    handleMenu()
    getBadge()
    fetchMyMedalSummary()
    // 防止会重复请求
    setTimeout(() => {
      isFirstLoad = false
    }, 1500)
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "head_img_wrap",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (onPrivacy('personCenter')))
        }, [
          _createElementVNode("img", {
            class: "head_img",
            src: _unref(avatarUrl),
            alt: "''"
          }, null, 8, _hoisted_4),
          (wearImageUrl.value)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "wear_img",
                src: wearImageUrl.value,
                alt: ""
              }, null, 8, _hoisted_5))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("p", {
              class: "username",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (onPrivacy('personCenter')))
            }, _toDisplayString(personName.value), 1),
            _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(jobDesc)), 1)
          ]),
          (
              !_unref(isTudoApp) &&
              !_unref(isSandsTalkFlutterApp) &&
              !_unref(isSandsTalkMSFlutterApp) &&
              !_unref(isSandsTalkNativeApp) &&
              !_unref(isSandsTalkSEAsiaOutfieldApp) &&
              !_unref(isSandsTalkPhOutfieldApp) &&
              !_unref(isWisdomRabbitApp)
            )
            ? (_openBlock(), _createBlock(QrCodeScanner, {
                key: 0,
                pageType: 2,
                onAddDecode: handleAdd
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navScreen.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "nav_item",
            key: item.to,
            onClick: ($event: any) => (goJump(item.to))
          }, [
            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t(item.num)), 1),
            _createElementVNode("p", _hoisted_12, [
              _createTextVNode(_toDisplayString(_ctx.$t(item.name)) + _toDisplayString(index === 0 ? '(h)' : '') + " ", 1),
              _createVNode(_unref(Icon), {
                name: "arrow",
                class: "arrow"
              })
            ])
          ], 8, _hoisted_10))
        }), 128)),
        (medalCount.value && medalCount.value > 0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "medal_entry",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (goJump('/myMedalList')))
            }, [
              _createElementVNode("div", _hoisted_13, [
                _cache[3] || (_cache[3] = _createElementVNode("img", {
                  class: "medal_entry_icon",
                  src: _imports_0,
                  alt: ""
                }, null, -1)),
                _createElementVNode("div", {
                  class: "medal_entry_text",
                  innerHTML: _ctx.$tVarHtml('您已获得枚勋章', [medalCount.value], { varClass: 'entry_num' })
                }, null, 8, _hoisted_14)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_unref(Icon), {
                  name: "arrow",
                  class: "arrow"
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t('app_my')), 1),
      _createElementVNode("div", _hoisted_18, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(myScreen.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "business_item",
            style: _normalizeStyle(index < 4 ? { paddingBottom: '20px' } : { paddingBottom: '15px' }),
            key: item.to,
            onClick: ($event: any) => (goJump(item.to))
          }, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("i", {
                class: _normalizeClass(['iconfont', item.img])
              }, null, 2),
              ((item.badgeNum || 0) > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString((item.badgeNum || 0) > 99 ? '99+' : item.badgeNum || 0), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.$t(item.name)), 1)
          ], 12, _hoisted_19))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$t('app_more')), 1),
      _createElementVNode("div", _hoisted_25, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(moreScreen.value, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "business_item",
            key: item.to,
            onClick: ($event: any) => (goJump(item.to))
          }, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("i", {
                class: _normalizeClass(['iconfont', item.img])
              }, null, 2),
              ((item.badgeNum || 0) > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString((item.badgeNum || 0) > 99 ? '99+' : item.badgeNum || 0), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.$t(item.name)), 1)
          ], 8, _hoisted_26))
        }), 128))
      ])
    ])
  ]))
}
}

})